var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            !_vm.isSuccess
              ? _c(
                  "form",
                  {
                    staticClass: "login-form custom-form",
                    attrs: { id: "login-form", novalidate: "" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.onSubmit)
                      }
                    }
                  },
                  [
                    _c("ValidationProvider", {
                      attrs: {
                        name: "Password",
                        rules: "required|passwordLength|password",
                        mode: "lazy"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field input__wrap password__wrap set__password__wrap",
                                    class: { "error-focus": errors.length > 0 }
                                  },
                                  [
                                    _vm.passwordType === "checkbox"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input password-has-icon required",
                                          class: {
                                            error: errors.length > 0,
                                            valid:
                                              _vm.password.length > 0 &&
                                              errors.length == 0
                                          },
                                          attrs: {
                                            id: "password",
                                            name: "password",
                                            required: "",
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            checked: Array.isArray(_vm.password)
                                              ? _vm._i(_vm.password, null) > -1
                                              : _vm.password
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.password,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.password = $$a.concat([
                                                      $$v
                                                    ]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.password = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.password = $$c
                                              }
                                            }
                                          }
                                        })
                                      : _vm.passwordType === "radio"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input password-has-icon required",
                                          class: {
                                            error: errors.length > 0,
                                            valid:
                                              _vm.password.length > 0 &&
                                              errors.length == 0
                                          },
                                          attrs: {
                                            id: "password",
                                            name: "password",
                                            required: "",
                                            type: "radio"
                                          },
                                          domProps: {
                                            checked: _vm._q(_vm.password, null)
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.password = null
                                            }
                                          }
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input password-has-icon required",
                                          class: {
                                            error: errors.length > 0,
                                            valid:
                                              _vm.password.length > 0 &&
                                              errors.length == 0
                                          },
                                          attrs: {
                                            id: "password",
                                            name: "password",
                                            required: "",
                                            type: _vm.passwordType
                                          },
                                          domProps: { value: _vm.password },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.password = $event.target.value
                                            }
                                          }
                                        }),
                                    _vm._v(" "),
                                    _c("label", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_NEW_PASSWORD",
                                          expression: "'INPUT_NEW_PASSWORD'"
                                        }
                                      ],
                                      staticClass: "login-form__field__label",
                                      attrs: { for: "password" }
                                    }),
                                    _vm._v(" "),
                                    _c("a", {
                                      staticClass: "icon--password fa fa-eye",
                                      on: {
                                        click: function($event) {
                                          return _vm.showPassword(
                                            "passwordType"
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "error-tooltip__wrap" },
                                      [
                                        _c("h4", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value: "INPUT_NEW_PASSWORD_ERROR",
                                              expression:
                                                "'INPUT_NEW_PASSWORD_ERROR'"
                                            }
                                          ],
                                          staticClass:
                                            "menu-link text-uppercase error-tooltip__content"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "description xxs-visible"
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(errors[0]) +
                                                "\n          "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("ValidationProvider", {
                      attrs: {
                        name: "confirm",
                        rules:
                          "required|passwordMatch:@Password|passwordLength|password",
                        mode: "lazy"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field input__wrap password__wrap set__password__wrap",
                                    class: { "error-focus": errors.length > 0 }
                                  },
                                  [
                                    _vm.confirmPasswordType === "checkbox"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.confirmPassword,
                                              expression: "confirmPassword"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input password-has-icon required",
                                          class: {
                                            error: errors.length > 0,
                                            valid:
                                              _vm.confirmPassword.length > 0 &&
                                              errors.length == 0
                                          },
                                          attrs: {
                                            id: "confirmPassword",
                                            name: "confirmPassword",
                                            required: "",
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.confirmPassword
                                            )
                                              ? _vm._i(
                                                  _vm.confirmPassword,
                                                  null
                                                ) > -1
                                              : _vm.confirmPassword
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.confirmPassword,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.confirmPassword = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.confirmPassword = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.confirmPassword = $$c
                                              }
                                            }
                                          }
                                        })
                                      : _vm.confirmPasswordType === "radio"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.confirmPassword,
                                              expression: "confirmPassword"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input password-has-icon required",
                                          class: {
                                            error: errors.length > 0,
                                            valid:
                                              _vm.confirmPassword.length > 0 &&
                                              errors.length == 0
                                          },
                                          attrs: {
                                            id: "confirmPassword",
                                            name: "confirmPassword",
                                            required: "",
                                            type: "radio"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.confirmPassword,
                                              null
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.confirmPassword = null
                                            }
                                          }
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.confirmPassword,
                                              expression: "confirmPassword"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input password-has-icon required",
                                          class: {
                                            error: errors.length > 0,
                                            valid:
                                              _vm.confirmPassword.length > 0 &&
                                              errors.length == 0
                                          },
                                          attrs: {
                                            id: "confirmPassword",
                                            name: "confirmPassword",
                                            required: "",
                                            type: _vm.confirmPasswordType
                                          },
                                          domProps: {
                                            value: _vm.confirmPassword
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.confirmPassword =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                    _vm._v(" "),
                                    _c("label", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_CONFIRM_PASSWORD",
                                          expression: "'INPUT_CONFIRM_PASSWORD'"
                                        }
                                      ],
                                      staticClass: "login-form__field__label",
                                      attrs: { for: "confirmPassword" }
                                    }),
                                    _vm._v(" "),
                                    _c("a", {
                                      staticClass: "icon--password fa fa-eye",
                                      on: {
                                        click: function($event) {
                                          return _vm.showPassword(
                                            "confirmPasswordType"
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "error-tooltip__wrap" },
                                      [
                                        _c("h4", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value: "INPUT_NEW_PASSWORD_ERROR",
                                              expression:
                                                "'INPUT_NEW_PASSWORD_ERROR'"
                                            }
                                          ],
                                          staticClass:
                                            "menu-link text-uppercase error-tooltip__content"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "description xxs-visible"
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(errors[0]) +
                                                "\n          "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "fieldset",
                      {
                        staticClass:
                          "login-form__field login-form__field--button"
                      },
                      [
                        _c(
                          "SubmitButton",
                          { attrs: { pending: _vm.isPending } },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("RESET_PASSWORD_BUTTON")) +
                                "\n      "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "backend-error-fade" } },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showErrorMsg,
                                expression: "showErrorMsg"
                              }
                            ],
                            staticClass: "text-center p-t-5"
                          },
                          [
                            _c("p", { staticClass: "text-danger" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.actionStatus.error) +
                                  "\n        "
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isSuccess
              ? _c("div", { staticClass: "success-message text-center" }, [
                  _c("h1", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "PASS_RESET_SUCCESS_TITLE",
                        expression: "'PASS_RESET_SUCCESS_TITLE'"
                      }
                    ],
                    staticClass: "title md-title"
                  }),
                  _vm._v(" "),
                  _c("p", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "PASS_RESET_SUCCESS_FIRST_LINE",
                        expression: "'PASS_RESET_SUCCESS_FIRST_LINE'"
                      }
                    ],
                    staticClass: "subtitle"
                  }),
                  _vm._v(" "),
                  _c("a", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "BACK_LOGIN_LINK",
                        expression: "'BACK_LOGIN_LINK'"
                      }
                    ],
                    staticClass: "button button--transparent-grad pulse m-t-40",
                    attrs: { href: "#" },
                    on: { click: _vm.goToLogin }
                  })
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }